import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {  FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-save-as',
  templateUrl: './save-as.dialog.html',
  styleUrls: ['./save-as.dialog.scss']
})
export class SaveAsDialog implements OnInit {

  exportFileName:string;
  saveAsForm:FormGroup;
  constructor(
    public dialogRef: MatDialogRef<SaveAsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    }

  ngOnInit(): void {
    this.saveAsForm = new FormGroup({
      exportFileName: new FormControl(this.data.fileName,Validators.required),
      fileFormat: new FormControl(this.data.selectedFormat.name,Validators.required),
      fileExtension : new FormControl(this.data.selectedFormat.primaryFormat,Validators.required),
    });
  }
  cancel(): void {
    this.dialogRef.close({saveData :false});
  }
  onSubmit(){
    if(this.saveAsForm.valid){
      this.dialogRef.close({
        saveData :true,
        response : this.saveAsForm.value
      });
    }
  }

}
